/* Zoheez theme behaviour: cart drawer, ajax add, accordions, nav, gallery, qty */
(function () {
  var routes = window.ZoheezRoutes || {};

  /* ---- mobile nav ---- */
  var nav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-nav-toggle]').forEach(function (b) {
    b.addEventListener('click', function () { if (nav) nav.classList.toggle('is-open'); });
  });

  /* ---- accordions ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-accordion-btn]');
    if (!btn) return;
    var item = btn.closest('[data-accordion-item]');
    var panel = item.querySelector('[data-accordion-panel]');
    var open = item.classList.toggle('is-open');
    panel.style.height = open ? panel.firstElementChild.offsetHeight + 'px' : '0px';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---- quantity ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value || '1', 10) + (b.dataset.qty === 'up' ? 1 : -1);
    input.value = Math.max(1, v);
  });

  /* ---- product gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.style.opacity = '0';
        setTimeout(function () { main.src = t.dataset.full; main.style.opacity = '1'; }, 180);
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  });

  /* ---- cart drawer ---- */
  var drawer = document.querySelector('[data-cart-drawer]');
  function openDrawer() { if (drawer) drawer.classList.add('is-open'); }
  function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(); openDrawer(); }
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function money(cents) {
    return (window.Shopify && Shopify.formatMoney && window.ZoheezMoneyFormat)
      ? Shopify.formatMoney(cents, window.ZoheezMoneyFormat)
      : 'Rs.' + (cents / 100).toFixed(2);
}

  function refreshCart() {
    fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    var wrap = document.querySelector('[data-cart-items]');
    var totalEl = document.querySelector('[data-cart-total]');
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count > 0 ? cart.item_count : ''; n.hidden = cart.item_count < 1; });
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (!wrap) return;
    if (!cart.items.length) { wrap.innerHTML = '<p style="opacity:.6">Your cart is empty.</p>'; return; }
    wrap.innerHTML = cart.items.map(function (i) {
      return '<div class="z-lineitem">' +
        (i.image ? '<img src="' + i.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') + '" alt="" width="64" height="64">' : '<div></div>') +
        '<div><strong>' + i.product_title + '</strong><br><small style="opacity:.6">Qty ' + i.quantity + '</small></div>' +
        '<div>' + money(i.line_price) + '</div></div>';
    }).join('');
  }

  /* ---- ajax add to cart ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!routes.cart_add_url) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      fetch(routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: parseInt(form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1, 10) }] })
      }).then(function (r) { return r.json(); })
        .then(function () { refreshCart(); openDrawer(); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });
  });

  /* ---- buy it now ---- */
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'One moment…';
      fetch(routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: form.querySelector('[name="id"]').value, quantity: parseInt(form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1, 10) }] })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { btn.disabled = false; btn.textContent = label; });
    });
  });

  /* ---- variant picker ---- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var data = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    var form = picker.closest('form');
    picker.addEventListener('change', function () {
      var chosen = [].slice.call(picker.querySelectorAll('input:checked')).map(function (i) { return i.value; });
      var match = data.find(function (v) { return v.options.join('~') === chosen.join('~'); });
      if (!match || !form) return;
      form.querySelector('[name="id"]').value = match.id;
      var priceEl = document.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = money(match.price);
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? (window.ZoheezStrings.addToCart) : window.ZoheezStrings.soldOut; }
    });
  });

  refreshCart();
})();
